module.exports = __webpack_public_path__ + "static/media/WhiteRightArrow.658617f7.svg";